import { VEHICLE_FEATURES, VEHICLE_TYPES } from '../constants';

export type TVehicleFeatureSelection = { vehicleFeatureId: number; selected: boolean };
export type TVehicleTypeSelection = { vehicleTypeId: number; selected: boolean };

export const getCommissionVehicleFeatureDefaultValue = (): TVehicleFeatureSelection[] => {
    return VEHICLE_FEATURES.map((featureId) => ({
        vehicleFeatureId: Number(featureId),
        selected: false,
    }));
};

export const getCommissionVehicleTypeDefaultValue = (): TVehicleTypeSelection[] => {
    return VEHICLE_TYPES.map((typeId) => ({
        vehicleTypeId: Number(typeId),
        selected: false,
    }));
};
